export const getGoogleAnalyticsClientId = (state) => state.googleAnalytics.clientId && state.googleAnalytics.clientId;
